<template>
<v-container>
    <div class="account-facebook mt-1">

        <v-avatar :size="40">

            <img :src="ImagePhoto" />

        </v-avatar>
        <div style="margin-left: 10px;font-weight: bold;">
            {{ facebook_name }}
        </div>

    </div>
    <v-divider class="mt-2"></v-divider>
    <v-row class="mt-2">
        <v-col cols="12" sm="12" md="12" lg="12">
            <v-text-field v-model="pageLink" label="Link Page" outlined dense></v-text-field>
            <v-btn id="btn_login" :loading="LoadingGetVideo" :disabled="LoadingGetVideo" block class="ma-0 red darken-1 white--text font-weight-black " @click="checkExpbeforeclone()" loading-text="Getting Video">
                GET VIDEO

            </v-btn>

        </v-col>
    </v-row>
    <div v-if="isLoadingVideo">
        <v-card class="mt-2">
            <v-row class="ma-2">
                <!-- <v-col v-for="(item, index) in datavideoList" :key="index" class="child-flex"  cols="4" lg="2"> -->
                <v-col v-for="(item, index) in datavideoList" :key="index" class="child-flex" cols="4" lg="2" md="3">
                    <!-- <p>{{ index }}</p> -->
                    <v-img :src="item.image" :lazy-src="item.image" aspect-ratio="1">

                        <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                        </template>

                    </v-img>

                    <v-checkbox label="Select Video" @change="selectVideo($event,index,item.title,item.source,item.image)"></v-checkbox>
                    <v-text-field class="" v-model="item.title" outlined dense>
                    </v-text-field>

                </v-col>
            </v-row>
            <div v-if="nextURLPost == ''">
                <div class="d-flex justify-center mb-6 bg-surface-var   iant">
                    No Video Avalilble
                </div>
            </div>
            <div v-else class="d-flex justify-center mb-6 bg-surface-variant">
                <v-btn :loading="isloadingNext" :disabled="isloadingNext" class="ma-3 red darken-1 white--text font-weight-black" @click="nextPost()">Next Post</v-btn>
            </div>
        </v-card>
        <v-btn id="btn_login" block :disabled="isLoadingPage" :loading="isLoadingPage" class="ma-0 red darken-1 white--text font-weight-black " @click="choosePage()" loading-text="Getting Video">
            Select Page

        </v-btn>
    </div>

    <v-dialog v-model="dialogChangeAccount" persistent max-width="290">

        <v-card>
            <v-card-title class="red" style="color: white;font-size: 14px">

                Notification

            </v-card-title>

            <v-card-text class="mt-2" style="font-size: 14px;color: black">
                Your Facebook Account Can't Post ! Please Change Your New Account Facebook
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="green darken-1" text @click="backtoHome()">
                    Back Home
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTrail" persistent max-width="290">

        <v-card>
            <v-card-title class="red" style="color: white;font-size: 14px">

                Notification

            </v-card-title>

            <v-card-text class="mt-2" style="font-size: 14px;color: black">
                Your Account is Trail Can't use the feature
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="green darken-1" text @click="backtoHome()">
                    Back Home
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogChoosePage" persistent max-width="500">

        <v-card>
            <v-card-title class="red" style="color: white;font-size: 16px">

                Clone

            </v-card-title>

            <v-card-text class="mt-2" style="font-size: 14px;color: black">
                <v-row class="mt-2">
                    <v-col cols="12" lg="12" xs="12" sm="12" md="12">
                        <v-text-field class="mt-1" label="CTA Title" v-model="cta_title" outlined dense>
                        </v-text-field>
                        <v-combobox v-model="selectPage" :items="getPages" item-value="id" item-text="name" :return-object="true" label="Select Pages" outlined dense></v-combobox>
                        <v-select v-model="seleceDelay" :items="deylayClone" item-value="deylayClone" item-text="name" :return-object="true" label="Delay" outlined dense></v-select>

                        <div v-if="isTrail == false">

                            <v-btn id="btn_login" :loading="loadingChangeImage" :disabled="loadingChangeImage" block class="ma-0  red darken-1 white--text font-weight-black " @click="getRigthSideImage()" loading-text="Getting Video">
                                Choose Image

                            </v-btn>
                        </div>
                        <div v-else>
                            <v-btn block id="btn_login" :disabled="isTrail" class=" rounded-xl red darken-1 white--text font-weight-black " @click="getRigthSideImage()" loading-text="Posting" style="font-size: 12px;">

                                Your plan can't choose image

                            </v-btn>
                        </div>

                        <div v-if="isError == false" class="mt-5 d-flex justify-center bg-surface-variant">
                            <div v-if="isCompleteClone == false">
                                {{ text_processing }} {{ clone_count }} of Video {{ videoSelected.length }}
                            </div>
                            <div v-else>
                                Clone Video Complete
                            </div>

                        </div>
                        <div v-else class="red white--text mt-5 d-flex justify-center bg-surface-variant">
                            <p class="ma-3">
                                {{ showMsgError }}
                            </p>
                        </div>

                    </v-col>

                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="done_clone()">
                    Close
                </v-btn>
                <v-btn color="green" text @click="post()" :disabled="isClone" :loading="isClone">
                    Clone Now
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar color="red">
                <v-toolbar-title style="color: white;">Choose Image</v-toolbar-title>
                <v-spacer>

                </v-spacer>
                <v-btn color="error" @click="dialogPreview = false">
                    <v-icon color="white">
                        mdi-close
                    </v-icon>

                </v-btn>

            </v-toolbar>

            <v-row class="ma-2">
                <v-col class="d-flex child-flex" cols="4" lg="1">
                    <input type="file" name="uploadimage" accept="image/*" id="uploadimage" ref="uploadimage" hidden @change="uploadToAd">
                    <div v-if="isUploadImagePE == true">
                        <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="black lighten-5"></v-progress-circular>
                        </v-row>

                    </div>
                    <v-img @click='uploadImage()' v-else src="https://www.thecamtool.com/dist/upload.jpeg" lazy-src="https://www.thecamtool.com/dist/upload.jpeg" aspect-ratio="1" class="grey lighten-2">
                        <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                        </template>
                    </v-img>
                </v-col>
                <v-col class="d-flex child-flex" cols="4" lg="1">
                    <v-img @click='getImageRigth("https://www.thecamtool.com/dist/rigth.png")' src="https://www.thecamtool.com/dist/rigth.png" lazy-src="https://www.thecamtool.com/dist/rigth.png" aspect-ratio="1" class="grey lighten-2">
                        <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                        </template>
                    </v-img>
                </v-col>

                <v-col v-for="(item, index) in ImageRigthSide" :key="index" class="child-flex" cols="4" lg="1">

                    <v-img @click="getImageRigth(item.url)" :src="item.url" :lazy-src="item.url" aspect-ratio="1">

                        <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                        </template>

                    </v-img>
                    <v-btn color="red" block @click="deleteImage(item.hash)" :disabled="item.hash == isDeleteImage">

                        <v-icon color="white" v-if="item.hash != isDeleteImage">
                            mdi-delete
                        </v-icon>
                        <v-progress-circular v-else indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-btn>

                </v-col>
            </v-row>
        </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

</v-container>
</template>

<script>
import axios from 'axios'
const source = axios.CancelToken.source();
export default {
    name: 'clone-pe',
    data: () => ({
        dialogTrail: false,
        isTrail: false,
        isCompleteClone: false, // check is clone complete
        showMsgError: "", // show message error
        cta_title: "Follow My Page",
        isClone: false,
        clone_count: 1,
        text_processing: "Start From  ",
        selectRigthImage: 'https://camfeed.net/image/logo_pe.jpg',
        loadingChangeImage: false,
        isUploadImagePE: false,
        isDeleteImage: '',
        ImageRigthSide: [],
        dialogPreview: false,
        selectPage: [],
        dialogChoosePage: false,
        isSelected: "",
        facebook_name: "Loading",
        ImagePhoto: "Hello",
      //  pageLink: "https://www.facebook.com/NeedU11",
        pageLink: "",
        LoadingGetVideo: false,
        isLoadingVideo: false, // for condition if loading in page
        userData: [], // for store user data from server,
        accessToken: "", // for get access token
        overlay: false,
        graph_version: "v20.0",
        id_facebook: "",
        isError: false, // check is error when cloniing
        adsSelected: "",
        dialogChangeAccount: false,
        datavideoList: [],
        selectedVideoPush: [], // for push video  to array for clone
        nextURLPost: '',
        isloadingNext: false,
        getPages: [],
        isLoadingPage: false,
        count_time:1,
        deylayClone: [
            {
                delay: "1",
                name: "1 Minutes"
            }, 
            {
                delay: "3",
                name: "3 Minutes"
            }, 
            {
                delay: "5",
                name: "5 Minutes"
            }, 
            {
                delay: "10",
                name: "10 Minutes"
            },
            
            {
                delay: "15",
                name: "15 Minutes"
            },
            {
                delay: "30",
                name: "30 Minutes"
            },
            {
                delay: "60",
                name: "1h"
            },
            {
                delay: "120",
                name: "2h"
            },
            // {
            //     delay: "1440",
            //     name: "1 Day"
            // }
        ],
        seleceDelay: [],
        index: 0,
        video_id: '',
        videoSelected: []

    }),
    created() {

        // console.log(moment(date).format('MMMM Do YYYY, h:mm:ss a'))
        // console.log(moment().add(30, 'minutes').format('X'))
         console.log(moment().add(15,'minutes').format('YYYY-MM-DD hh:mm '))
        this.userData = JSON.parse(localStorage.getItem('info'))
        this.accessToken = localStorage.getItem('accessToken');

    },
    mounted() {
        //this.getProfileWithADS()
        this.checkExpUser()
    },

    methods: {
      
        selectVideo(val, index, title, source,image) {
            if (val == true) {
                this.videoSelected.push({
                    id:index,
                    title: title,
                    source: source,
                    image: image

                });
            }else{
              
                this.videoSelected = this.videoSelected.filter((e)=>e.id !== index )
            }

        //    console.log(this.videoSelected)

        },
        backtoHome() {

            this.$router.push('dashboard').catch(err => {})
        },
        checkExpUser() {
            axios.get('https://app.camsmartbiz.com/user/checkexp/' + this.userData.data.user.id).then((data) => {

                if (data.data.data.expired == true) {

                    this.$router.push('expired').catch(err => {})

                } else {
                    this.getProfileWithADS()
                }

            }).catch((err) => {
                this.$swal('Error', "Request to Network ", 'error');
            }).finally(() => {

            })
        },
        deleteImage(h) {
            var $t = this
            $t.isDeleteImage = h
            $.ajax({
                type: "DELETE",
                url: 'https://graph.facebook.com/v18.0/' + this.adsSelected + '/adimages',
                data: {
                    hash: h,
                    access_token: this.accessToken
                }
            }).then(function (data) {
                $t.isDeleteImage = ""
                $t.getRigthSideImage()
            }, function (data) {
                $t.isDeleteImage = ""
                $t.getRigthSideImage()
            })

        },
        uploadToAd(event) {

            const files = event.target.files;
            let filename = files[0].name;
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () => {
                this.imageRigthSideURL = fileReader.result
            })

            fileReader.readAsDataURL(files[0])
            this.imageRigthSideURL = files[0]
            this.uploadToFacebook()

        },

        uploadToFacebook() {
            this.isUploadImagePE = true
            var bodyFormData = new FormData();
            bodyFormData.append("filename", this.imageRigthSideURL)
            bodyFormData.append("access_token", this.accessToken)
            axios.post(
                'https://graph.facebook.com/' + this.adsSelected + '/adimages', bodyFormData
            ).then((data) => {

                this.getRigthSideImage()
                this.isUploadImagePE = false
            }).catch((err) => {
                this.getRigthSideImage()
            }).finally((err) => {
                // this.getRigthSideImage()
                this.isUploadImagePE = false
            })

        },
        uploadImage() {

            this.$refs.uploadimage.click();

        },
        getRigthSideImage() {

            this.loadingChangeImage = true;
            axios.get('https://graph.facebook.com/' + this.adsSelected + '/adimages', {
                params: {
                    access_token: this.accessToken,
                    fields: "id,url,hash"
                }
            }).then((data) => {
                this.dialogPreview = true
                this.loadingChangeImage = false
                this.ImageRigthSide = data.data.data
                console.log(this.ImageRigthSide)
            }).catch(() => {
                this.loadingChangeImage = false
                this.$swal('Request', 'Request error', 'error');
            })

        },
        getImageRigth(url) {

            this.dialogPreview = false
            this.selectRigthImage = url

        },
        selectVideoclone(title, source) {

            this.selectedVideoPush.push({
                title: title,
                source: source,

            });

            // console.log(this.selectedVideoPush)

        },
        nextPost() {

            this.isloadingNext = true
            axios.get(this.nextURLPost,

            ).then((data) => {

                // console.log(data.data.data)

                /// Link page https://www.facebook.com/NeedU11
                var title = "";
                var obj = []
                data.data.data.forEach((item) => {
                    title = item.message

                    item.attachments.data.forEach((video) => {
                        // console.log(video)

                        if (Object.prototype.hasOwnProperty.call(video, "subattachments")) {
                            video.subattachments.data.forEach((element, index) => {

                                if (element.type == "video_autoplay" || element.type == "video_direct_response_autoplay") {
                                    if (element.media.source !== undefined && title !== undefined) {
                                        this.datavideoList.push({
                                            title: title,
                                            source: element.media.source,
                                            image: element.media.image.src

                                        })

                                    }

                                }

                            });

                        } else {

                            if (Object.prototype.hasOwnProperty.call(video, "media")) {
                                if (video.type != "photo") {

                                    if (element.media.source !== undefined && title !== undefined) {
                                        this.datavideoList.push({
                                            title: title,
                                            source: element.media.source,
                                            image: element.media.image.src

                                        })

                                    }

                                }

                            }

                        }

                    })

                })
                // this.datavideoList=obj
                this.isLoadingVideo = true
                // this.nextURLPost=data.data.paging.next;
                // console.log(this.datavideoList)
                if (Object.prototype.hasOwnProperty.call(data.data.paging, "next")) {
                    this.nextURLPost = data.data.paging.next;

                } else {
                    this.nextURLPost = ""
                }
            }).catch((data) => {
                this.isloadingNext = false
            }).finally((data) => {
                this.isloadingNext = false
            })

        },
        getPageIDFromLink() {
            this.LoadingGetVideo = true
            axios.get('https://graph.facebook.com/' + this.graph_version + '?id=' + this.pageLink, {

                    params: {

                        access_token: this.accessToken

                    }
                }

            ).then((data) => {

                // console.log(data.data.id)
                this.datavideoList = []
                this.getSourceVideo(data.data.id)
            }).catch((data) => {
                this.LoadingGetVideo = false
                // this.errorMSG(data)
            }).finally((data) => {
                // this.LoadingGetVideo= false
            })

        },

        getSourceVideo(id) {

            this.LoadingGetVideo = true
            axios.get('https://graph.facebook.com/' + this.graph_version + '/' + id + '/feed', {

                    params: {

                        access_token: this.accessToken,

                        fields: "attachments,message"

                    }
                }

            ).then((data) => {

                // console.log(data.data.data)

                /// Link page https://www.facebook.com/NeedU11

                var title = "";
                var obj = []
                data.data.data.forEach((item) => {
                    title = item.message

                    item.attachments.data.forEach((video) => {
                        // console.log(video)

                        if (Object.prototype.hasOwnProperty.call(video, "subattachments")) {
                            video.subattachments.data.forEach((element, index) => {

                                if (element.type == "video_autoplay" || element.type == "video_direct_response_autoplay") {
                                    if (element.media.source !== undefined && title !== undefined) {
                                        this.datavideoList.push({
                                            title: title,
                                            source: element.media.source,
                                            image: element.media.image.src

                                        })

                                    }

                                }

                            });

                        } else {

                            if (Object.prototype.hasOwnProperty.call(video, "media")) {
                                if (video.type != "photo") {

                                    if (element.media.source !== undefined && title !== undefined) {
                                        this.datavideoList.push({
                                            title: title,
                                            source: element.media.source,
                                            image: element.media.image.src

                                        })

                                    }

                                }

                            }
                        }

                    })

                })
                // this.datavideoList = obj
                // this.datavideoList=obj

                this.isLoadingVideo = true
                if (Object.prototype.hasOwnProperty.call(data.data.paging, "next")) {
                    this.nextURLPost = data.data.paging.next;

                } else {
                    this.nextURLPost = ""
                }

            }).catch((data) => {
                this.LoadingGetVideo = false
            }).finally((data) => {
                this.LoadingGetVideo = false
            })

        },
        choosePage() {
        
            this.isLoadingPage = true
            if(this.videoSelected.length == 0 )
            {
                this.isLoadingPage = false;
                this.$swal('Video', "Please select your video for clone", 'warning');
                return
                
            }
     
            // var obj_video = []
            // // var count_time = 1
            // this.videoSelected.forEach((item, index) => {
            //     var total_time = this.seleceDelay.delay * this.count_time++
            //     obj_video.push({
            //         source: item.source,
            //         image: item.image,
            //         title: item.title,
            //         time_delay: moment().add(total_time, 'minutes').format('X'),
            //         time_no_cv: total_time,
            //         time_add: moment().add(total_time, 'minutes').format('YYYY-MM-DD HH:mm ')

            //     })
            // })
            // this.selectedVideoPush = obj_video
            // console.log(this.selectedVideoPush)
            axios.get('https://graph.facebook.com/' + this.id_facebook + '/accounts',

                {
                    params: {
                        access_token: this.accessToken,
                        limit: 100,
                        fields: "id,name,access_token"
                    }

                }).then((data) => {

                var obj = []

                data.data.data.forEach((item, index) => {

                    obj.push({
                        name: item.name,
                        id: item.id,
                        access_token: item.access_token,
                        status: ''

                    })

                });

                this.getPages = obj
                this.dialogChoosePage = true
                this.isLoadingPage = false

            }).catch((data) => {
                this.$swal('Error', this.errorMSG(data), 'error');
                this.isLoadingPage = false

            }).finally((data) => {
                this.isLoadingPage = false
            })

        },
        checkExpbeforeclone() {
            if (this.pageLink == '') {
                this.$swal('Opps!', 'Please Enter Link Page', 'warning')
                return;
            }
            this.LoadingGetVideo = true
            axios.get('https://app.camsmartbiz.com/user/checkexp/' + this.userData.data.user.id).then((data) => {

                if (data.data.data.expired == true) {

                    this.$router.push('expired').catch(err => {})

                } else {
                    if (data.data.data.plan == 0) {
                        this.isTrail = true
                        this.dialogTrail = true

                    } else {
                        this.isTrail = false
                    }
                    this.getPageIDFromLink()
                }

            }).catch((err) => {
                this.LoadingGetVideo = false
                this.$swal('Error', "Request to Network ", 'error');
            }).finally(() => {

            })

        },
        checkExpUser() {
            axios.get('https://app.camsmartbiz.com/user/checkexp/' + this.userData.data.user.id).then((data) => {

                if (data.data.data.expired == true) {

                    this.$router.push('expired').catch(err => {})

                } else {
                    this.getProfileWithADS()
                }

            }).catch((err) => {
                this.$swal('Error', "Request to Network ", 'error');
            }).finally(() => {

            })
        },

        getProfileWithADS() {

            this.overlay = true
            axios.get('https://graph.facebook.com/me', {

                    params: {

                        access_token: this.accessToken

                    }
                }

            ).then((data) => {

                var hasPropertyError = Object.prototype.hasOwnProperty.call(data.data, "error");
                if (hasPropertyError) {

                    this.$swal('Profile', this.errorMSG(data), 'error');

                } else {
                    console.log(data)

                    this.id_facebook = data.data.id;

                    this.facebook_name = data.data.name

                    var urlimage = "https://graph.facebook.com/" + this.id_facebook + "/picture?height=500&access_token=6628568379%7Cc1e620fa708a1d5696fb991c1bde5662";

                    this.ImagePhoto = urlimage;

                    this.getAdsAccont()

                }

            }).catch((data) => {

                this.overlay = true
                this.$router.push('dashboard')

            }).finally((data) => {

                this.overlay = false

            })

        },

        getAdsAccont() {

            // for get ads account

            axios.get('https://graph.facebook.com/' + this.graph_version + '/' + this.id_facebook + '/adaccounts', {

                params: {
                    access_token: this.accessToken,
                    fields: "id,account_id,name,account_status"
                }

            }).then((data) => {

                if (data.data.data.length == 1) {

                    if (data.data.data[0].account_status == 2 || data.data.data[0].account_status != 1) {

                        this.isError = true
                        this.dialogChangeAccount = true
                    } else {
                        this.adsSelected = data.data.data[0].id
                    }

                    // this.adsSelected = item.id

                } else {

                    if (data.data.data.length > 0) {
                        data.data.data.forEach((item) => {

                            if (item.account_status == 2 || item.account_status != 1) {

                                this.isError = true
                                this.dialogChangeAccount = true
                                //return 0;

                            } else {

                                this.adsSelected = item.id
                            }

                        })
                    } else {

                        this.isError = true
                        this.dialogAdsAccount = true

                    }

                }

            }).catch((data) => {

                //                this.$swal('Error', this.errorMSG(data), 'error');    
                this.isError = true
                this.msgError = this.errorMSG(data)

            })

        },

        errorMSG(data) {
            var msgTitle = "";
            var msgDesc = "";

            if (data.hasOwnProperty("response")) {
                if (data.response.data.error.hasOwnProperty("error_user_title")) {
                    msgTitle = data.response.data.error.error_user_title;

                    msgDesc = data.response.data.error.error_user_msg.replace(/"/g, "'");
                } else {
                    msgTitle = data.response.data.error.type;

                    msgDesc = data.response.data.error.message;
                }
            } else {
                msgTitle = "No Internet";
                msgDesc = "Please check your internet connection";
            }

            return msgDesc
        },

        post() {
            this.isError = false
            if(this.isClone == false)
            {

                var obj_video = []
                this.videoSelected.forEach((item, index) => {
                    var total_time = this.seleceDelay.delay * this.count_time++
                    obj_video.push({
                        source: item.source,
                        image: item.image,
                        title: item.title,
                        time_delay: moment().add(total_time, 'minutes').format('X'),
                        time_no_cv: total_time,
                        time_add: moment().add(total_time, 'minutes').format('YYYY-MM-DD HH:mm ')

                    })
                })
                this.selectedVideoPush = obj_video

            }
            if (this.selectPage.length == 0) {
                this.$swal('Page', 'Please select your page', 'warning')
                return
            }

            if (this.seleceDelay.length == 0) {
                this.$swal('Delay', 'Please select your delay clone', 'warning')
                return
            }
            this.isClone = true

            if (this.selectedVideoPush.length == 0) {
              //  console.log(this.selectedVideoPush)
                this.$swal('Clone', 'Cannot get video for clone', 'error')
                return
            }

            if (this.index < this.selectedVideoPush.length) {

                var bodyFormData = new FormData();
                bodyFormData.append('access_token', this.accessToken)
                bodyFormData.append('file_url', this.selectedVideoPush[this.index].source)
                this.text_processing = "Creating AdVideo"
                axios.post('https://graph.facebook.com/' + this.graph_version + '/' + this.adsSelected + '/advideos', bodyFormData, {
                    cancelToken: source.token
                }).then((data) => {

                    if (Object.prototype.hasOwnProperty.call(data.data, "error")) {

                        this.$toast.error(this.errorMSG(data), {

                            position: 'bottom-right',
                        });

                    } else {
                        // this.video_id = data.data.id
                        var cta_value = {}
                        cta_value["page"] = this.selectPage.id;
                        var cta = {
                            type: "LIKE_PAGE",
                            value: cta_value
                        }
                        if (this.cta_title == '') {
                            this.cta_title = this.selectPage.name
                        }
                        var data_post = {
                            name: moment(moment(), "DD MMM YYYY hh:mm A").format("X"),
                            object_story_spec: {
                                page_id: this.selectPage.id,
                                link_data: {
                                    message: this.selectedVideoPush[this.index].title,
                                    caption: "https://web.facebook.com/" + this.selectPage.id,
                                    link: "https://web.facebook.com/" + this.selectPage.id,
                                    multi_share_optimized: false,
                                    child_attachments: [{
                                            name: this.cta_title,
                                            link: "https://web.facebook.com/" + this.selectPage.id,
                                            video_id: data.data.id,
                                            // video_id: this.video_id,
                                            // picture: this.selectedThum,
                                            picture: this.selectedVideoPush[this.index].image,
                                            call_to_action: cta
                                        },
                                        {
                                            name: this.cta_title,
                                            link: "https://web.facebook.com/" + this.selectPage.id,
                                            picture: this.selectRigthImage,
                                            call_to_action: cta
                                        }
                                    ]

                                }

                            },
                            access_token: this.accessToken,

                        }

                        this.text_processing = "Creating Adcreative"
                        axios.post('https://graph.facebook.com/' + this.graph_version + '/' + this.adsSelected + '/adcreatives', data_post, {
                            cancelToken: source.token
                        }).then((data) => {
                            var hasPropertyError = Object.prototype.hasOwnProperty.call(data.data, "error");

                            if (hasPropertyError) {

                                // this.isError = true
                                // this.showMsgError = this.errorMSG(data)
                                this.clone_count++
                                this.index++
                                this.post()
                                this.isError = true
                                this.showMsgError = this.errorMSG(data)
                            } else {

                                setTimeout(() => {
                                    this.try_to_publish(data.data.id)
                                }, 5000);

                            }

                        }).catch((data) => {

                            if (axios.isCancel(data)) {

                            } else {
                                this.clone_count++
                                this.index++
                                this.post()
                                this.isError = true
                                this.showMsgError = this.errorMSG(data)

                            }

                        }).finally((data) => {

                        })
                    }

                }).catch((data) => {
                    if (axios.isCancel(data)) {

                    } else {

                        this.isError = true
                        this.showMsgError = this.errorMSG(data)
                    }

                })

            } else {
                this.isCompleteClone = true;
                this.done_clone()

            }

        },
        try_to_publish(id_adtive) {
            this.text_processing = "Getting ID"
            axios.get('https://graph.facebook.com/' + this.graph_version + '/' + id_adtive, {
                    params: {
                        access_token: this.accessToken,
                        fields: 'effective_object_story_id'
                    },
                    cancelToken: source.token

                }

            ).then((effect) => {

                var haseffect = Object.prototype.hasOwnProperty.call(effect.data, "effective_object_story_id");
                if (haseffect) {
                    var d = {

                        access_token: this.selectPage.access_token,

                    }
                    this.text_processing = "Publishing"
                    if (this.index == 0) {
                        d['is_published'] = true
                        // d['scheduled_publish_time'] = this.selectedVideoPush[this.index].time_delay

                        axios.post('https://graph.facebook.com/' + this.graph_version + '/' + effect.data.effective_object_story_id, d, {
                                cancelToken: source.token
                            })
                            .then((data) => {
                                this.text_processing = "Posted"
                                this.clone_count++
                                this.index++
                                this.post()

                            }).catch((data) => {

                                if (axios.isCancel(data)) {

                                } else {
                                    // this.clone_count++
                                    // this.index++
                                    // this.post()

                                    this.isError = true
                                    this.showMsgError = this.errorMSG(data)
                                    this.done_error()

                                }
                            })

                    } else {

                        // d['scheduled_publish_time'] = this.selectedVideoPush[this.index].time_delay
                        var user = JSON.parse(localStorage.getItem('info'));
                        var coookie_cam = JSON.parse(localStorage.getItem('Cam'));
                        var FormDataSave = new FormData();
                        FormDataSave.append('post_id', effect.data.effective_object_story_id);
                        FormDataSave.append('user_id', user.data.user.id);
                        FormDataSave.append('schedule_time', this.selectedVideoPush[this.index].time_delay);
                        FormDataSave.append('token', this.selectPage.access_token);
                        FormDataSave.append('cookie', coookie_cam.cookie);
                        FormDataSave.append('date_time', this.selectedVideoPush[this.index].time_add);

                        axios.post('https://app.camsmartbiz.com/user/saveschedule', FormDataSave, {
                                cancelToken: source.token
                            })
                            .then((data) => {
                                this.text_processing = "Save Schedule"
                                this.clone_count++
                                this.index++
                                this.post()

                            }).catch((data) => {

                                if (axios.isCancel(data)) {

                                } else {
                                    // this.clone_count++
                                    // this.index++
                                    // this.post()

                                    this.isError = true
                                    this.showMsgError = "Request Error "
                                    this.done_error()

                                }
                            })

                    }

                } else {

                    setTimeout(() => {
                        this.try_to_publish(id_adtive)
                    }, 5000);

                }

            }).catch((data) => {

                if (axios.isCancel(data)) {

                } else {
                    // this.clone_count++
                    // this.index++
                    // this.post()
                    this.isError = true
                    this.showMsgError = this.errorMSG(data)

                    this.done_error()

                }

            })

        },
        done_clone() {
            this.isCompleteClone = false;
            this.selectedVideoPush = []
            this.index = 0
            this.text_processing = "Start From"
            this.count_time = 1
            this.isClone = false
            this.isLoadingVideo = false
            this.dialogChoosePage = false
            this.videoSelected =[]
            source.cancel('Operation canceled by the user.');
            // location.reload()

        },

        done_error() {
            // this.isCompleteClone = false;

            this.selectedVideoPush = []
            this.index = 0
            this.text_processing = "Start From"
            this.count_time = 1
            this.isClone = false
            this.videoSelected =[]

            // this.dialogChoosePage = false
        }

    }
}
</script>
